import { render } from "./GiftPrint.vue?vue&type=template&id=461ad0d2&scoped=true"
import script from "./GiftPrint.vue?vue&type=script&lang=js"
export * from "./GiftPrint.vue?vue&type=script&lang=js"

import "./GiftPrint.vue?vue&type=style&index=0&id=461ad0d2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-461ad0d2"]])

export default __exports__